import { ValidationResult } from "@components/WizardCst/types";
import { UserWizardData } from "./types";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateMainInfo = (data: UserWizardData): ValidationResult => {
  const errors: Record<string, string> = {};

  if (!data.name?.trim()) errors.name = "required";
  if (!data.surname?.trim()) errors.surname = "required";
  if (!data.external_id?.trim()) errors.external_id = "required";
  if (!data.username?.trim()) errors.username = "required";
  if (!data.email?.trim()) errors.email = "required";
  else if (!EMAIL_RE.test(data.email)) errors.email = "invalidEmail";
  if (!data.roles || data.roles.length === 0) errors.roles = "required";

  return { valid: Object.keys(errors).length === 0, errors };
};
